import { render, staticRenderFns } from "./user-agreement-update.vue?vue&type=template&id=e3c9f68e&"
import script from "./user-agreement-update.vue?vue&type=script&lang=js&"
export * from "./user-agreement-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports